module.exports = __webpack_public_path__ + "img/dbsf.5be4442d.jpg";